import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetFleets = ApiClient['v2']['workspaces'][':workspaceId']['fleets']['$get'];
type FleetsListQuery = InferRequestType<GetFleets>['query'];
type FleetsListResponse = InferResponseType<GetFleets, 200>;

export function useFleets(workspaceId: number, query: FleetsListQuery = {}) {
  return useFetch<FleetsListResponse>(
    `workspaces/${workspaceId}/fleets?${JSON.stringify(query)}`,
    (client) =>
      client.v2.workspaces[':workspaceId'].fleets.$get({
        param: { workspaceId: workspaceId.toString() },
        query,
      }),
    undefined,
    { keepPreviousData: true }
  );
}
